/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_DaysInputs */

const en_planner_days = /** @type {(inputs: Planner_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Days`)
};

const de_planner_days = /** @type {(inputs: Planner_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tage`)
};

/**
* | output |
* | --- |
* | "Days" |
*
* @param {Planner_DaysInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_days = /** @type {((inputs?: Planner_DaysInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_DaysInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_days(inputs)
	return en_planner_days(inputs)
});